import { Helmet } from "react-helmet";
import Article from "./Article";
import { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

const KnowledgeBase = () => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_BASE_URL + "crafter/knowledge-base-list/"
      );
      setData(res.data);
    } catch (error) {
      console.error("Error fetching articles:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Storlytics | Knowledge Base</title>
      </Helmet>

      <Main>
        <Section>
          {data.map((article, index) => (
            <Article key={index} {...article} />
          ))}
        </Section>
      </Main>
    </>
  );
};

export default KnowledgeBase;

const Main = styled.main`
  padding: 32px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Section = styled.section`
  display: flex;
  flex-direction: column; /* Stack articles vertically */
  gap: 24px; /* Add spacing between articles */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto; /* Center the section horizontally */

  @media (max-width: 768px) {
    gap: 16px; /* Reduce spacing on mobile */
  }
`;
